import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'user-rate-us',
    templateUrl: './rate-us.component.html',
    styleUrls: ['./rate-us.component.scss'],
    standalone: false
})
export class RateUsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
